import {
  LOADING_REBATES,
  FETCH_REBATES,
  FETCH_REBATE,
  SET_FILTRO_REBATES,
  RESET_REBATES
} from '../actions/types';

const initialState = {
  loadingRebates: false,
  rebates: {
    content: [],
    total: 0
  },
  rebate: {},
  filtro: {}
}

export default function (state = initialState, action) {

  switch (action.type) {

    case LOADING_REBATES:
      return {
        ...state,
        loadingRebates: action.payload
      };

    case SET_FILTRO_REBATES:
      return {
        ...state,
        filtro: action.payload
      };

    case FETCH_REBATES:
      const normalizedPayload = action.payload?.rebates ?? action.payload ?? { content: [], total: 0 };
      return {
        ...state,
        rebates: normalizedPayload
      };

    case FETCH_REBATE:
      return {
        ...state,
        rebate: action.payload
      };

      case RESET_REBATES:
        return {
          ...state,
          filtro: action.payload,
          rebates: { content: [], total: 0 }
        };
      

    default:
      return state
  }
}